










import {Vue, Component, Prop} from 'vue-property-decorator';
import {NavigationPanel} from '@/components/NavigationPanel';
import {mapGetters, mapActions} from 'vuex';

@Component({
  name: 'ProfileApartmentOne',
  components: {
      NavigationPanel,
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      withoutTabs: ['leaseContractClose'],
    };
  },
  computed: {
    ...mapGetters([
        'navigation',
    ]),
    subLinks() {
      let rightLinks;
      this.navigation.map((link) => {
        if (link.name === 'profile' && link.children) {
          link.children.map((subLink) => {
            if (subLink.name === 'myApartments' && subLink.children) {
              rightLinks = subLink.children[0].children?.filter((item) => {
                return item.name !== 'leaseContractClose' && item.name !== 'leaseContractProlong';
              });
            }
          });
        }
      });
      return rightLinks;
    },
  },
})
export default class ProfileApartmentOne extends Vue {}
